// 1. Composant pour afficher les conditions médicales
// components/consultation/summary/MedicalConditionsList.tsx
import React from 'react';

interface MedicalConditionsListProps {
  conditions: { [key: string]: boolean | string };
  bgColor: string;
  borderColor: string;
}

export const MedicalConditionsList: React.FC<MedicalConditionsListProps> = ({
  conditions,
  bgColor,
  borderColor,
}) => {
  const activeConditions = Object.entries(conditions)
    .filter(([, v]) => v === true || (typeof v === "string" && v));

  if (activeConditions.length === 0) {
    return (
      <p className="text-gray-500 text-sm">Aucune condition signalée</p>
    );
  }

  return (
    <div className="flex flex-wrap gap-2 text-sm">
      {activeConditions.map(([k, v]) => (
        <span
          key={k}
          className={`${bgColor} border ${borderColor} rounded px-2 py-1`}
        >
          {k}
          {typeof v === "string" && v !== "true" && v !== "false"
            ? `: ${v}`
            : ""}
        </span>
      ))}
    </div>
  );
};